import type { ProcessingRun } from './api'

export function filterProcessingRuns(runs: ProcessingRun[], search: string) {
  const needle = search.trim().toLocaleLowerCase('vi-VN')
  if (!needle) return runs
  return runs.filter((run) => [
    run.platform_order_id,
    run.customer_phone_masked,
    run.tester_id,
    run.client_name,
    run.feedback_note,
    run.current_message,
  ].some((value) => String(value || '').toLocaleLowerCase('vi-VN').includes(needle)))
}
